import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { setFillablePDFMetadata as setFillablePDFMetadataAction } from '../../options/store/options.actions'
import { FillablePdfsService } from '../services/fillablePdfs.service'
import { FillablePDFsConstants } from '../store/fillablePDFs.constants'

export function* setFillablePDFMetadata() {
  const serviceId: string = yield select(getServiceIdSelector)
  const fillablePdfsService = new FillablePdfsService(serviceId)
  try {
    const fillablePdfMetadataResponse: IOptionsResponse = yield call([
      fillablePdfsService,
      fillablePdfsService.getFillablePdfMetadataDoc,
    ])
    yield put(setFillablePDFMetadataAction(fillablePdfMetadataResponse?.entity || []))
  } catch (e) {
    yield put(setFillablePDFMetadataAction([]))
    yield put(throwPcrException(`setFillablePDFMetadata() error: ${e}`))
  }
}

export function* setFillablePDFMetadataSaga() {
  yield takeLatest([FillablePDFsConstants.ON_FILLABLE_PDFS_IMPORT_SUCCESS], setFillablePDFMetadata)
}
